import { render, staticRenderFns } from "./SupplierSelector.vue?vue&type=template&id=09541ad8&scoped=true&"
import script from "./SupplierSelector.vue?vue&type=script&lang=js&"
export * from "./SupplierSelector.vue?vue&type=script&lang=js&"
import style0 from "./SupplierSelector.vue?vue&type=style&index=0&id=09541ad8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09541ad8",
  null
  
)

export default component.exports